import { z } from 'zod';
/**
 * What an organisation is allowed, and what it has used.
 *
 * Its own module because two surfaces describe the same thing: an operator
 * assigning plans across every organisation, and an organisation reading its
 * own. Defined once, so the figures on the two screens cannot come to mean
 * different things — the shapes sat in `admin.ts` and `settings.ts` for about
 * an hour and the duplication check caught them, which is exactly what it is
 * there for.
 */
export const planLimitsSchema = z.object({
    /** Null is not capped, and is not zero. */
    seats: z.number().int().nullable(),
    contacts: z.number().int().nullable(),
    sendsPerMonth: z.number().int().nullable(),
    aiTokensPerMonth: z.number().int().nullable(),
});
/** Counted now, never kept in a counter column that could drift from the rows. */
export const planUsageSchema = z.object({
    seats: z.number().int(),
    contacts: z.number().int(),
    sendsThisMonth: z.number().int(),
    aiTokensThisMonth: z.number().int(),
});
//# sourceMappingURL=plan.js.map